<template>
  <div>
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>
        <b-button
          variant="outline-primary"
          @click="showModalAdd()"
        >
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }}
          </span>
        </b-button>
      </template>
    </app-breadcrumb>

    <!-- Filters -->
    <repair-list-filters @search="searchAll" />

    <!-- Table Container Card -->
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card
        no-body
        class="mb-0"
      >
        <b-table
          ref="refUserListTable"
          class="position-relative table-nowrap"
          :items="itemsData"
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          responsive
          show-empty
          empty-text="Không tìm thấy kết quả"
          :sort-desc.sync="isSortDirDesc"
        >

          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <!-- Column: Actions -->
          <template #cell(status)="row">
            <!-- <b-badge v-if="row.item.status === 10" pill :variant="row.item.status === 10 ? 'dark' : ''" @click="changeStatus(row.item.id, 20, 'Nhận sửa')" title="Nhận sửa">
              Đang chờ sửa
            </b-badge>
            <b-badge v-if="row.item.status === 20" pill :variant="row.item.status === 20 ? 'info' : ''"  @click="changeStatus(row.item.id, 30, 'Hoàn thành')" title="Hoàn thành">
              Đang chờ sửa
            </b-badge>
            <b-badge v-if="row.item.status === 30" pill :variant="row.item.status === 30 ? 'success' : ''">
              Đang chờ sửa
            </b-badge> -->

            <!-- Đang chờ duyệt -->
            <b-dropdown
              v-if="row.item.status === 10"
              :variant="row.item.status === 10 ? 'gradient-secondary' : ''"
              id="dropdown-left"
              text="Đang chờ duyệt"
              size="sm"
            >
              <b-dropdown-item @click="changeStatus(row.item.id, 20, 'Nhận sửa thiết bị')">Nhận sửa thiết bị</b-dropdown-item>
              <b-dropdown-item @click="changeStatus(row.item.id, 40, 'Từ chối sửa thiết bị')">Từ chối sửa thiết bị</b-dropdown-item>
            </b-dropdown>
            <!-- Đang sửa -->
            <b-dropdown
              v-if="row.item.status === 20"
              :variant="row.item.status === 20 ? 'gradient-info' : ''"
              id="dropdown-left"
              text="Đang sửa"
              size="sm"
            >
              <b-dropdown-item @click="changeStatus(row.item.id, 30, 'Hoàn thành sửa thiết bị')">Hoàn thành sửa</b-dropdown-item>

            </b-dropdown>
            <!-- Hoàn thành -->
            <b-dropdown
              v-if="row.item.status === 30"
              :variant="row.item.status === 30 ? 'gradient-success' : ''"
              id="dropdown-left"
              text="Đã sửa xong"
              size="sm"
            >
            </b-dropdown>
            <!-- Từ chối -->
            <b-dropdown
              v-if="row.item.status === 40"
              :variant="row.item.status === 40 ? 'gradient-danger' : ''"
              id="dropdown-left"
              text="Từ chối"
              size="sm"
            >
            </b-dropdown>

          </template>
          <template #cell(actions)="row">
            <b-button
              v-if="row.item.status === 10 || row.item.status === 20"
              size="sm"
              variant="outline-primary"
              class="ml-1 btn-icon"
              @click="edit(row.item)"
              v-b-tooltip.hover
              title="Sửa"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
            <b-button
              size="sm"
              variant="outline-primary"
              class="ml-1 btn-icon"
              @click="show(row.item)"
              v-b-tooltip.hover
              title="Xem chi tiết"
            >
              <feather-icon icon="EyeIcon" />
            </b-button>
            <b-button
              v-if="row.item.status === 10 || row.item.status === 20 || row.item.status === 40"
              size="sm"
              class="ml-1 btn-icon"
              variant="outline-danger"
              v-b-tooltip.hover
              title="Xóa"
              @click="confirmDelete(row.item.id)"
            >
              <span class="text-nowrap">
                <feather-icon icon="TrashIcon" />
              </span>
            </b-button>
          </template>

          <!-- Column: created_at -->
          <template #cell(created_at)="row">
            {{ formatDate(row.item.created_at) }}
          </template>
          <!-- Column: repair_begin_date -->
          <template #cell(repair_begin_date)="row">
            {{ row.item.repair_begin_date ? formatDate(row.item.repair_begin_date) : '' }}
          </template>
          <!-- Column: repair_finish_date -->
          <template #cell(repair_finish_date)="row">
            {{ row.item.repair_finish_date ? formatDate(row.item.repair_finish_date) : '' }}
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('show_to_entries', {
                from: dataMeta.from, to: dataMeta.to, of: dataMeta.of
              })
              }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalEntries"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </b-overlay>

    <b-modal
      id="showRelate1"
      body-class=" mb-2"
      size="lg"
      @close="dialog"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      hide-footer
      :title="editMode ? 'Cập nhật' : 'Thêm mới'"
    >
      <repair-edit
        :mdata="frmData"
        @updateData="handleDialog"
      />
    </b-modal>
    <b-modal
      id="showModalAdd"
      body-class=" mb-2"
      size="lg"
      @close="dialogAdd"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      hide-footer
      title="Form sửa thiết bị"
    >
      <repair-add @updateData="handleDialog" />
    </b-modal>
    <b-modal
      id="showDetail"
      body-class=" mb-2"
      size="lg"
      @close="dialogDetail"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      hide-footer
      title="Thông tin"
    >
      <repair-show :mdata="frmData" />
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email, alphaNum, min, max, } from '@validations'
import {
  BOverlay, BCard, BRow, BCol, BButton, BTable, BFormCheckbox,
  BBadge, BPagination, BModal, BFormGroup, BFormTextarea, BFormInput, BForm, BFormInvalidFeedback, BDropdown, BDropdownItem, VBTooltip
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import { showToast } from '@/@core/utils/utils'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import RepairListFilters from './RepairListFilters.vue'
import useRepair from './useRepair'
import formValidation from '@core/comp-functions/forms/form-validation'
import store from '@/store';
import RepairEdit from './RepairEdit.vue';
import RepairShow from './RepairShow.vue';
import RepairAdd from './RepairAdd.vue';
import moment from 'moment'
import Ripple from 'vue-ripple-directive';


export default {
  components: {
    AppBreadcrumb,
    RepairListFilters,
    BOverlay,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BBadge,
    BPagination,
    BFormCheckbox,
    BModal, BFormGroup, BFormTextarea, BFormInput,
    ValidationProvider, ValidationObserver,
    BForm, BFormInvalidFeedback,
    RepairEdit,
    RepairShow,
    RepairAdd,
    BDropdown,
    BDropdownItem,

  },
  data() {
    return {
      editMode: false,
    }
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  setup() {
    const isAddNewUserSidebarActive = ref(false)
    const blankData = {
      name_en: '',
      name_vi: '',
      code: '',
    }
    const frmData = ref(JSON.parse(JSON.stringify(blankData)))
    const resetfrmData = () => {
      frmData.value = JSON.parse(JSON.stringify(blankData))
    }
    const {
      loading,
      fetchAll,
      tableColumns,
      perPage,
      currentPage,
      totalEntries,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      itemsData
    } = useRepair()

    fetchAll();
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(frmData)
    return {
      fetchAll,
      // Sidebar
      isAddNewUserSidebarActive,
      loading,
      tableColumns,
      perPage,
      currentPage,
      totalEntries,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      itemsData,
      frmData,
      getValidationState,
      resetfrmData
    }
  },
  methods: {
    handleDialog() {
      this.$bvModal.hide('showRelate1')
      this.$bvModal.hide('showModalAdd')
      this.fetchAll();
      this.resetfrmData();
    },
    dialog() {
      this.editMode = false
      this.resetfrmData();
      this.$bvModal.show('showRelate1')
    },

    edit(item) {
      this.frmData = item;
      this.editMode = true;
      this.$bvModal.show('showRelate1')
    },
    show(item) {
      this.frmData = item;
      this.$bvModal.show('showDetail')
    },
    dialogDetail() {
      this.$bvModal.hide('showDetail')
    },
    showModalAdd() {
      this.$bvModal.show('showModalAdd')
    },
    dialogAdd() {
      this.$bvModal.hide('showModalAdd')
    },

    confirmDelete(id) {
      this.$swal({
        title: 'Bạn chắc muốn xóa?',
        text: 'Xóa dữ liệu sẽ ảnh hưởng đến các chức năng khác trong hệ thống!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('device/destroyOneRepair', { id }).then((res) => {
            if (res.status === 200) {
              this.fetchAll();
              showToast(res.data.message, { variant: 'success' });
            } else {
              showToast(res.data.message);
            }
          })
        }
      })
    },
    formatDate(value) {
      return moment(String(value)).format('DD-MM-YYYY H:m')
    },
    changeStatus(id, status, msg) {
      // this.frmData = item;
      // this.editMode = true;
      // this.$bvModal.show('showRelate1')
      this.$swal({
        title: 'Bạn chắc muốn thay đổi trạng thái?',
        text: msg,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('device/changeStatusRepair', { id: id, status: status }).then((res) => {
            if (res.status === 200) {
              this.fetchAll();
              showToast(res.data.message, { variant: 'success' });
            } else {
              showToast(res.data.message);
            }
          })
        }
      })
    },

    searchAll(data) {
      this.searchQuery.keyword = data.keyword
      this.searchQuery.created_at = data.created_at
      this.searchQuery.repair_begin_date = data.repair_begin_date
      this.searchQuery.repair_finish_date = data.repair_finish_date
      this.fetchAll()
    }
  },

}
</script>
